import { cn } from '@dogdisk/shared'
import { useGoBack } from '../_lib/use-go-back'

/**
 * 全站统一返回按钮(对齐 .pen GdTtT/qlC4p:44×44 / rounded-xl / #F6F7F8 / arrow-left)。
 * 默认行为走 useGoBack(history 弹栈,深链 fallback);传 onClick 可覆盖
 * (如弹窗关闭/带清理的返回)。fallback 仅在无可弹历史时生效。
 */
export function BackButton({
  fallback,
  onClick,
  className,
}: {
  fallback?: string | undefined
  onClick?: (() => void) | undefined
  className?: string | undefined
}) {
  const goBack = useGoBack(fallback)
  return (
    <button
      type="button"
      aria-label="返回"
      data-testid="back-button"
      onClick={onClick ?? goBack}
      className={cn(
        'flex h-11 w-11 items-center justify-center rounded-xl bg-[#F6F7F8] text-[#1A1A1A] active:bg-[#EDEEF0]',
        className,
      )}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M19 12H5M12 19l-7-7 7-7" />
      </svg>
    </button>
  )
}
